export function ToggleSwitch({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: () => void;
}) {
  return (
    <label className="caddietw-relative caddietw-inline-flex caddietw-items-center caddietw-cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="caddietw-sr-only caddietw-peer"
      />
      <div className="caddietw-w-9 caddietw-h-5 caddietw-bg-gray-300 peer-focus:caddietw-outline-none peer-focus:caddietw-ring-2 peer-focus:caddietw-ring-blue-300 caddietw-rounded-full peer peer-checked:after:caddietw-translate-x-full peer-checked:after:caddietw-border-white after:caddietw-content-[''] after:caddietw-absolute after:caddietw-top-[2px] after:caddietw-left-[2px] after:caddietw-bg-white after:caddietw-border-gray-300 after:caddietw-border after:caddietw-rounded-full after:caddietw-h-4 after:caddietw-w-4 after:caddietw-transition-all peer-checked:caddietw-bg-blue-600" />
    </label>
  );
}
